import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';

@Component({
  selector: 'app-send-sms-confirm-dialog',
  templateUrl: './send-sms-confirm-dialog.component.html',
  styleUrls: ['./send-sms-confirm-dialog.component.scss']
})
export class SendSmsConfirmDialogComponent implements OnInit {
  form: FormGroup;
  countries: any[];
  hint: string = '';

  constructor(
    public dialogRef: MatDialogRef<SendSmsConfirmDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private baseService: BaseService,
    public dialog: MatDialog
  ) {
    this.form = fb.group({
      countryNumber: [null, Validators.compose([Validators.required])],
      phoneNumber: [null, Validators.compose([Validators.required])],
      message: [null, Validators.compose([Validators.required, Validators.maxLength(160)])],
      salesOrderHeaderId: [null],
      salesOrderNumber: [null]
    });

    this.form.patchValue(data);
   }

  ngOnInit() {
    this.baseService.executeCommand<any>('portal_send_sales_order_sms_config', this.form.value)
    .subscribe(response => {
      if (response.responseCode === 0) {
        this.countries = response.data.countries || [];
        if (response.data.defaultCountryNumber) {
          this.form.controls['countryNumber'].setValue(response.data.defaultCountryNumber);
        }
        this.countrieChanged();
      }
    });
  }

  countrieChanged() {
    this.form.controls['phoneNumber'].clearValidators();
    this.form.controls['phoneNumber'].setValue(null);
    this.hint = '';
    if (this.form.value.countryNumber) {
      const country = this.countries.find(f => f.countryNumber === this.form.value.countryNumber);
      if (country) {
        this.form.controls['phoneNumber'].setValidators(Validators.compose([Validators.required,Validators.pattern(country.regex.replace(/\\\\/g, '\\'))]));
        this.hint = country.hint;
      }
    }
  }

  send() {
    this.baseService.executeCommand('portal_oi_group_send_sales_order_sms', this.form.value)
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.dialogRef.close(true);
        }
      });
  }

}
